<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t("transactions.markAsPaidTitle") }}</p>
      <button
        type="button"
        class="delete"
        @click="$parent.close()"
        :disabled="isSubmitting"
      />
    </header>

    <section class="modal-card-body">
      <p>{{ $t("transactions.markAsPaidMessage") }}</p>

      <br />

      <b-field :label="$t('transactions.markAsPaidAuthorization')">
        <b-input
          v-model="authorization"
          type="text"
          maxlength="50"
          :disabled="isSubmitting"
        />
      </b-field>

      <b-field :label="$t('transactions.cardBrand')">
        <b-select
          v-model="cardFlag"
          :placeholder="$t('transactions.markAsPaidChooseCardBrand')"
          :disabled="isSubmitting"
          expanded
        >
          <option value="visa">Visa</option>
          <option value="master">Mastercard</option>
          <option value="outros">
            {{ $t("transactions.markAsPaidOtherBrands") }}
          </option>
        </b-select>
      </b-field>

      <b-field>
        <b-checkbox v-model="deductStock" :disabled="isSubmitting">
          {{ $t("transactions.markAsPaidDeductStock") }}
        </b-checkbox>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <button
        class="button"
        type="button"
        @click="$parent.close()"
        :disabled="isSubmitting"
      >
        {{ $t("common.cancel") }}
      </button>
      <button
        class="button is-success"
        type="button"
        :disabled="!canSubmit"
        :class="{ 'is-loading': isSubmitting }"
        @click="submit"
      >
        {{ $t("transactions.markAsPaid") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";

export default {
  props: ["transaction"],

  mixins: [common],

  data() {
    return {
      authorization: "",
      cardFlag: null,
      deductStock: true,
      isSubmitting: false
    };
  },

  computed: {
    canSubmit() {
      return (
        this.authorization.trim().length > 0 &&
        !!this.cardFlag &&
        !this.isSubmitting
      );
    }
  },

  methods: {
    submit() {
      this.isSubmitting = true;

      this.$store
        .dispatch("markTefTransactionPaid", {
          transactionId: this.transaction._id,
          authorization: this.authorization.trim(),
          cardFlag: this.cardFlag,
          deductStock: this.deductStock
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.toast.open({
              message: this.$t("transactions.markAsPaidSuccess"),
              type: "is-success"
            });

            this.$emit("marked-as-paid");
            this.$parent.close();
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    }
  }
};
</script>
